import CalendarButton from "../atoms/CalendarButton";
import DatePickerField from "./DatePickerField";
import DateNavigator from "./DateNavigator";

// YYYYMM 文字列 → Date オブジェクト（月初日）
const parseYearMonth = (ym) =>
  new Date(parseInt(ym.slice(0, 4), 10), parseInt(ym.slice(4, 6), 10) - 1, 1);

// Date オブジェクト → YYYYMM 文字列
const formatYearMonth = (d) =>
  `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;

/**
 * YearMonthNavigator - 年月切り替えナビゲーター
 * MonthlyDataPage と OfficeInputPage で共用する。
 *
 * @param {string}   yearMonth - 現在の年月 (YYYYMM形式)
 * @param {function} onChange  - 年月変更時のコールバック (YYYYMM文字列を受け取る)
 */
function YearMonthNavigator({ yearMonth, onChange }) {
  const changeMonth = (delta) => {
    const year = parseInt(yearMonth.slice(0, 4), 10);
    const month = parseInt(yearMonth.slice(4, 6), 10);
    const d = new Date(year, month - 1 + delta, 1);
    onChange(`${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`);
  };

  return (
    <DateNavigator
      prevLabel="◀ 前月"
      nextLabel="翌月 ▶"
      onPrev={() => changeMonth(-1)}
      onNext={() => changeMonth(1)}
      gapClass="gap-4"
    >
      <DatePickerField
        selected={parseYearMonth(yearMonth)}
        onChange={(d) => onChange(formatYearMonth(d))}
        customInput={<CalendarButton yyyyValue={yearMonth} />}
        showMonthYearPicker
        dateFormat="yyyy年MM月"
        locale="ja"
        calendarClassName="datepicker-month-picker"
        popperPlacement="bottom-start"
        popperProps={{ strategy: "fixed" }}
        enableTabLoop={false}
      />
    </DateNavigator>
  );
}

export default YearMonthNavigator;
